import HttpCliente from "../HttpCliente";

export const analizarImpactoArchivo = (token, archivo) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("archivo", archivo);

    HttpCliente.post("/AnalizadorImpacto/AnalizarArchivo", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then((r) => resolve(r.data))
      .catch((e) => {
        console.error("Error al analizar impacto:", e.response?.data || e);
        reject(e.response?.data?.message || "Error al analizar el documento");
      });
  });
};

export const reanalizarImpacto = (token, idNormativa) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post(`/Normativa/reanalizar/${idNormativa}`, null, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then((r) => resolve(r.data))
      .catch((e) => {
        console.error("Error al reanalizar:", e.response?.data || e);
        reject(e.response?.data?.message || "Error al reintentar el análisis");
      });
  });
};